import Icon from "../Icon";
import React, {useEffect, useState} from "react";
import {getSessionId} from "../../services/session";
import {useMutation, useQuery} from "@apollo/react-hooks";
import USER from "../../graphql/queries/user";
import ADD_FAVOURITE_COTTAGE from "../../graphql/mutations/addCottageStayToWishlist";
import REMOVE_FAVOURITE_COTTAGE from "../../graphql/mutations/removeCottageStayFromWishlist";

const isCottageMarkedAsFavourite = (cottageId, cottageIds) => {
    if (cottageIds.find(id => id === cottageId)) {
        return true;
    }

    return false;
}

const findStayId = (cottageId, stays) => {
    const stay = stays.find(stay => stay.cottage.id === cottageId);

    if (stay) {
        return stay.id;
    }

    return null;
}

const CardOverlayHearth = ({ cottageId }) => {
    const [isFavourite, setIsFavourite] = useState(false);
    const [addFavouriteCottage] = useMutation(ADD_FAVOURITE_COTTAGE);
    const [removeFavouriteCottage] = useMutation(REMOVE_FAVOURITE_COTTAGE);
    const uuid = getSessionId();

    const { loading, error, data } = useQuery(USER, {
        variables: {
            uuid: uuid
        }
    });

    useEffect(() => {
        if (!data || !data.user) {
            return;
        }

        const cottageIds = data.user.wishlist.cottageStays.map(cottageStay => cottageStay.cottage.id);
        setIsFavourite(isCottageMarkedAsFavourite(cottageId, cottageIds));
    }, [data])

    return (
        <div className="card-img-overlay-top text-right">
            <span
                onClick={() => {
                    isFavourite
                        ? removeFavouriteCottage({ variables: { uuid: uuid, stayId: findStayId(cottageId, data.user.wishlist.cottageStays) } })
                        : addFavouriteCottage({ variables: { uuid: uuid, cottageId: cottageId } })
                    setIsFavourite(!isFavourite)}
                }
                className={`card-fav-icon position-relative z-index-40 favourite ${isFavourite ? 'selected-favourite' : ''}`}>
                <Icon icon="heart-1" className={`${isFavourite ? 'text-white' : 'text-black'}`} />
                {/*<i className={`${isFavourite ? 'far fa-heart text-white' : 'far fa-heart text-black'}`}/>*/}
            </span>
        </div>
    )
}

export default CardOverlayHearth;
